import React from 'react'
import './InputCheckbox.css'
import MessageUI from "../output/MessageUI";

const InputCheckBoxUI = (
  {
    name, label, messageList, labelKey, onChange, required, checked, error, help
  }) =>
  <div className={`w_input_fld checkbox ${error ? 'hasError' : ''} ${required ? 'required' : ''} ${name}`}>

    <input type="checkbox" id={"input-checkbox-" + name + "-id"} name={name} onChange={onChange} checked={checked}/>

    {
      label &&
      <label htmlFor={"input-checkbox-" + name + "-id"}>{label}</label>
    }
    {
      labelKey &&
      <label htmlFor={"input-checkbox-" + name + "-id"}>
        <MessageUI messageList={messageList} messageKey={labelKey}/>
      </label>
    }
    {
      help &&
      <div className='help g_muted'>{help}</div>
    }
  </div>

export default InputCheckBoxUI
